import { render, staticRenderFns } from "./IconCameraSwitch.vue?vue&type=template&id=55f1878c"
import script from "./IconCameraSwitch.vue?vue&type=script&lang=js"
export * from "./IconCameraSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports